import type {Message as GqlMessage} from "@/types/api";
import {Enum_Message_Type} from "@/utils/graphql/generated/graphql";
import {useGameStore} from "@/state/gameStore";

/**
 * Returns the text to display for a message.
 * For Pre_Room_Transition messages, returns the roomTransitionText from the
 * automatically selected (next) room; otherwise returns the message's own text.
 */
export function useMessageDisplayText(message: GqlMessage | null): string {
    const nextRoom = useGameStore((state) => state.nextRoom);

    if (!message) return "";

    if (message.type !== Enum_Message_Type.PreRoomTransition || !nextRoom) {
        return message.text ?? "";
    }

    return nextRoom.roomTransitionText?.trim() ?? message.text ?? "";
}